import { createReducer } from "reduxsauce";
import Actions from "./auth-actions";

const INITITAL_STATE = {
  loginMethod: null
};

const setLoginMethod = (state = INITITAL_STATE, action) => ({
  ...state,
  loginMethod: action.method
});

const HANDLERS = {
  [Actions.Types.SET_LOGIN_METHOD]: setLoginMethod
};

export default createReducer(INITITAL_STATE, HANDLERS);



// WEBPACK FOOTER //
// ./src/modules/auth/auth-reducer.js